<nav id="subNav" class="hasIcons">
	<ul>
		<li uiSrefActive="active">
      <a uiSref="^.risk">
        <fa-icon icon="font"></fa-icon>
        <i class="fas fa-font"></i>
        <small>{{ 'PAGES.EVALUATION.MENU.RISK' | translate}}</small>
		  </a>
    </li>
	</ul>
</nav>
